import type { RootState } from '~/redux/store';
import type { Campaign } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getItem = (state: RootState): Campaign | null => state.campaigns.item;

export const getParams = (state: RootState): IRestIndexParams<Campaign> => ({
  sortBy: state.campaigns.sortBy,
  page: state.campaigns.page,
  pageSize: state.campaigns.pageSize,
  with: state.campaigns.with.join(','),
  ...state.campaigns.filters,
});
